/* global globalThis */
import './App.css';
import React, { useEffect } from "react";
import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import DocMng from './pages/mngr/DocMng';
import NtfctMng from './pages/mngr/NtfctMng';
import ProtectedRoute from './components/ProtectedRoute';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

function App() {
  
  const theme = createTheme(); // MUI 기본 테마 생성

  useEffect(() => {
    globalThis.session = globalThis.sessionStorage;
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/login" element={<Login />} />
        <Route path="/docMng" element={
          <ProtectedRoute>
            <DocMng />
          </ProtectedRoute>
          }
        />
        <Route path="/ntfctMng" element={
          <ProtectedRoute>
            <NtfctMng />
          </ProtectedRoute>
          }
        />
      </Routes>
    </ThemeProvider>
  )
}

export default App
